// extracted by mini-css-extract-plugin
export default {"Container":"Styles_Container__rWIE+","Tutor":"Styles_Tutor__BhCF3","calender":"Styles_calender__J96Sh"};